export const sizes = {
  inputHeight: '60px',
  pageContentWidth: '1170px',
  pageSidePadding: '90px',
  pageSidePaddingS: '20px',
  sidebarWidth: '60px',
  textLineHeight: '26px',
  textFontSize: '1rem',
};
